export const color = {
  black: '#030303',
  black100: '#141414',
  black200: '#333333',
  gray: '#626262',
  gray100: '#E7E7E7',
  gray200: '#C4C4C4',
  white: '#FFFFFF',
  white100: '#FFFFFF1A',
  white200: '#FFFFFF33',
  primary: '#EC1F50',
  yellow: '#EDD225',
  blue: '#0096FF',
  green: '#24F68C',
  orange: '#FB8B02',
  purple: '#685CFF',
  cyan: '#69FFED',
  pink: '#FE4C89',
  red: '#13030B',
};

/* styled-components theme */
export const theme = {
  color,
};
